var chunkMapping = {
	"943": [
		13459,
		53482,
		94805,
		80261,
		58787
	],
	"1611": [
		71611
	],
	"9318": [
		59470
	]
};
var idToExternalAndNameMapping = {
	"13459": [
		"default",
		"./CartButtonFloat",
		89018
	],
	"53482": [
		"default",
		"./ChatNavigator",
		89018
	],
	"58787": [
		"default",
		"./NewCartButtonFloat",
		89018
	],
	"59470": [
		"default",
		"./Injector",
		94366
	],
	"71611": [
		"default",
		"./App",
		85394
	],
	"80261": [
		"default",
		"./NewCustomerChatTemplate",
		89018
	],
	"94805": [
		"default",
		"./CustomerChatTemplate",
		89018
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}